/**
 * Static content imports.
 *
 * JSON is imported (not read from disk) so the content ships inside the browser
 * bundle and so a missing file is a build error rather than a runtime 404.
 */

import classes from '../data/classes.json' with { type: 'json' };
import dice from '../data/dice.json' with { type: 'json' };
import facts from '../data/facts.json' with { type: 'json' };
import npcs from '../data/npcs.json' with { type: 'json' };
import dialogue from '../data/dialogue.json' with { type: 'json' };
import monsters from '../data/monsters.json' with { type: 'json' };
import dungeon from '../data/dungeon.json' with { type: 'json' };
import encounters from '../data/encounters.json' with { type: 'json' };
import cards from '../data/cards.json' with { type: 'json' };
import items from '../data/items.json' with { type: 'json' };
import easterEggs from '../data/easter-eggs.json' with { type: 'json' };

export const CONTENT_FILES: Record<string, unknown> = {
  'classes.json': classes,
  'dice.json': dice,
  'facts.json': facts,
  'npcs.json': npcs,
  'dialogue.json': dialogue,
  'monsters.json': monsters,
  'dungeon.json': dungeon,
  'encounters.json': encounters,
  'cards.json': cards,
  'items.json': items,
  'easter-eggs.json': easterEggs,
};
